import MeasureArea from '@apps-common/ui-icons/Area.jsx';
import MeasureIcon from '@apps-common/ui-icons/Measure.jsx';
import {Typography} from '@mui/material';
import {func, object, oneOf} from 'prop-types';
import React from 'react';

import AreaIndicator from './area-indicator.jsx';
import LengthIndicator from './length-indicator.jsx';

export const MeasureIndicator = ({geometry, onClick, iconSize = 'medium'}) => {
  // render nothing if there is no geometry
  if (!geometry) {
    return false;
  }

  const style = {
    marginLeft: 1.5,
    display: 'inline-block',
  };

  if (onClick) {
    style['&:hover'] = {
      textDecoration: 'underline',
      cursor: 'pointer',
    };
  }

  return (
    <React.Fragment>
      {geometry.type === 'LineString' ? (
        <MeasureIcon fontSize={iconSize} />
      ) : (
        <MeasureArea fontSize={iconSize} />
      )}
      <Typography
        data-qe="area-measurement"
        onClick={onClick}
        sx={style}
        variant="body2"
      >
        {geometry.type === 'LineString' ? (
          <LengthIndicator geometry={geometry} />
        ) : (
          <AreaIndicator geometry={geometry} />
        )}
      </Typography>
    </React.Fragment>
  );
};

MeasureIndicator.propTypes = {
  geometry: object,
  iconSize: oneOf(['small', 'medium', 'large']),
  onClick: func,
};
